<template>
    <div class="card">
        <div class="card-header">
            <div class="d-sm-flex justify-content-between">
                <h2 class="card-title mb-0 text-nowrap">
                    <font-awesome-icon :icon="['fas', 'balance-scale']" /> Gewichtung
                </h2>
            </div>
        </div>
        <div class="body p-4">
            <p>
                Bitte wähle die Themen aus, die <strong>doppelt</strong> gewichtet werden sollen:
            </p>

            <ul class="list-group" v-if="answer.length > 0">
                <button class="list-group-item list-group-action" :disabled="answer[index] === null" :class="{ 'list-group-item-primary': weight[index] }" v-for="(question, index) in questions" :key="index" @click="toggleWeight(index)">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex text-left">
                            <span class="text-muted mr-2">{{ index + 1}}.</span>
                            <div>
                                <div>{{ question.title }}</div>
                                <div v-if="weight[index]" style="font-size: 75%">
                                    {{ question.text }}
                                </div>
                            </div>
                        </div>
                        <div class="ml-2">
                            <mat-vote-icon :value="answer[index]" />
                        </div>
                    </div>
                </button>
            </ul>

            <div class="d-flex justify-content-between mt-3">
                <div class="mt-2 text-left"><button type="button" class="btn btn-light" @click="$emit('back')">
                    <font-awesome-icon icon="arrow-left" fixed-width />
                    zu den Fragen
                </button></div>
                <div class="mt-2 text-right"><button type="button" class="btn btn-primary" @click="$emit('forward')">
                    <span>zum Ergebnis</span>
                    <font-awesome-icon icon="arrow-right" fixed-width />
                </button></div>
            </div>
        </div>
    </div>
</template>

<script>
import MatVoteIcon from './MatVoteIcon';

import questions from '../data/questions';

export default {
    name: "MatWeights",
    components: {
        MatVoteIcon
    },
    props: {
        answer: Array
    },
    data() {
        return {
            questions,
            weight: Array(questions.length).fill(false)
        }
    },
    computed: {
        questionCount() {
            return this.questions.length;
        }
    },
    methods: {
        toggleWeight(index) {
            this.$set(this.weight, index, !this.weight[index]);
        }
    },
    watch: {
        weight: {
            handler(value) {
                this.$emit('weight', value);
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>